module.exports = __webpack_public_path__ + "img/salvador-de-bahia.7742ea54.jpg";